<script lang="ts" setup>
import type { DynamicAuctionItemList } from '@autobid/strapi-integration/rest/components'
import { filterNotSearchableKeys } from '@autobid/ui/utils/filterNotSearchableKeys'
import { computed, inject } from 'vue'

defineProps<Props>()

const auctionStrapiData = inject<DynamicAuctionItemList>('auction-strapi-data')

interface Props {
  resultsAmount?: number
}

const route = useRoute()
const queryOfSearchEngine = filterNotSearchableKeys(route.query)
const searchUrlWithParams = computed(() => {
  if (!auctionStrapiData?.vehicleSearchUrl)
    return undefined

  const params = Object.entries(queryOfSearchEngine)
    .reduce((acc: string[], param) => {
      const [key, value] = param
      const values = Array.isArray(value) ? value : [value]

      return acc.concat(values.map(val => `${key}=${val}`))
    }, [])
    .join('&')

  return `${auctionStrapiData?.vehicleSearchUrl}?${params}`
})
</script>

<template>
  <div
    class="full-width-component w-full border-y bg-primary py-3 md:bg-transparent xl:mb-3"
  >
    <div class="container mx-auto flex items-center justify-between gap-3 px-3">
      <div class="flex items-center">
        <ElementsButton
          v-if="searchUrlWithParams"
          color="primary"
          rounded="primary"
          class="!md:w-full mr-2 !w-auto !px-3 md:mr-5 md:min-w-[246px]"
          :url="searchUrlWithParams"
          :aria-label="$t('cars-list.search-results.back-to-vehicle-search')"
        >
          <span class="hidden items-center md:flex">
            <Icon mode="svg" class="-ml-2 h-8 w-8" name="mdi:chevron-left" />
            {{ $t('cars-list.search-results.back-to-vehicle-search') }}
          </span>

          <CommonIconArrow class="h-8 w-8 md:hidden" />
        </ElementsButton>

        <component
          :is="auctionStrapiData?.headingSearchTitle?.name ?? 'p'"
          class="text-lg font-semibold sm:text-xl md:text-2xl"
        >
          <span class="text-white md:text-primaryDark">
            {{
              auctionStrapiData?.searchTitle
                ? `${auctionStrapiData?.searchTitle} (${resultsAmount ?? 0})`
                : $t('cars-list.search-results.found-results', {
                  amount: resultsAmount ?? 0,
                })
            }}
          </span>
        </component>
      </div>

      <template v-if="resultsAmount">
        <DynamicAuctionItemListSorting class="hidden md:block" />
        <DynamicAuctionItemListFiltersMobileButton class="md:hidden" />
      </template>
    </div>
  </div>
</template>
